import { render, staticRenderFns } from "./dialog-dvf.vue?vue&type=template&id=ad3cbdb4&scoped=true"
import script from "./dialog-dvf.vue?vue&type=script&lang=ts"
export * from "./dialog-dvf.vue?vue&type=script&lang=ts"
import style0 from "./dialog-dvf.vue?vue&type=style&index=0&id=ad3cbdb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3cbdb4",
  null
  
)

export default component.exports